import React, { useState, useEffect } from 'react';
import {
    countUsersAttemptedByTestSeriesExamTestTypeId,
    countUsersSubmittedByTestSeriesExamTestTypeId,
    getAverageScoreByTestSeriesExamTestTypeId,
    getHighestScoreByTestSeriesExamTestTypeId,
    getLowestScoreByTestSeriesExamTestTypeId,
    getAverageTimeTakenByTestSeriesExamTestTypeId,
    getPaidUsersCountByTestSeriesExamTestTypeId,
} from '../../../api/testSeries/category';
import { useParams } from 'react-router-dom';
const CategoryStats = (props) => {
    const { id } = useParams()// get the id from the URL params
    const [attemptedUsersCount, setAttemptedUsersCount] = useState(0);
    const [submittedUsersCount, setSubmittedUsersCount] = useState(0);
    const [averageScore, setAverageScore] = useState(0);
    const [highestScore, setHighestScore] = useState(0);
    const [lowestScore, setLowestScore] = useState(0);
    const [averageTimeTaken, setAverageTimeTaken] = useState(0);
    const [paidUsersCount, setPaidUsersCount] = useState(0);

    useEffect(() => {
        async function fetchCategoryStats() {
            const [attemptedUsersCountRes, submittedUsersCountRes, averageScoreRes, highestScoreRes, lowestScoreRes, averageTimeTakenRes, paidUsersCountRes,] = await Promise.all([
                countUsersAttemptedByTestSeriesExamTestTypeId(id),
                countUsersSubmittedByTestSeriesExamTestTypeId(id),
                getAverageScoreByTestSeriesExamTestTypeId(id),
                getHighestScoreByTestSeriesExamTestTypeId(id),
                getLowestScoreByTestSeriesExamTestTypeId(id),
                getAverageTimeTakenByTestSeriesExamTestTypeId(id),
                getPaidUsersCountByTestSeriesExamTestTypeId(id),
            ]);

            if (attemptedUsersCountRes.status) {
                setAttemptedUsersCount(attemptedUsersCountRes.data);
            }

            if (submittedUsersCountRes.status) {
                setSubmittedUsersCount(submittedUsersCountRes.data);
            }

            if (averageScoreRes.status) {
                setAverageScore(averageScoreRes.data);
            }

            if (highestScoreRes.status) {
                setHighestScore(highestScoreRes.data);
            }

            if (lowestScoreRes.status) {
                setLowestScore(lowestScoreRes.data);
            }

            if (averageTimeTakenRes.status) {
                setAverageTimeTaken(averageTimeTakenRes.data);
            }

            if (paidUsersCountRes.status) {
                setPaidUsersCount(paidUsersCountRes.data);
            }
        }

        fetchCategoryStats();
    }, [id]);

    return (
        <div>
            <h2>Category Statistics</h2>
            <div className="row">
                <div className="col-12 col-lg-6">
                    <div className="card radius-15">
                        <div className="card-body">
                            <div className="media align-items-center">
                                <div className="media-body">
                                    <h4 className="mb-0 font-weight-bold">{attemptedUsersCount}</h4>
                                    <p className="mb-0">Number of users who attempted this category</p>
                                </div>
                                <div className="widgets-icons bg-light-primary text-primary rounded-circle">
                                    <i className="bx bx-poll"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-lg-6">
                    <div className="card radius-15">
                        <div className="card-body">
                            <div className="media align-items-center">
                                <div className="media-body">
                                    <h4 className="mb-0 font-weight-bold">{submittedUsersCount}</h4>
                                    <p className="mb-0">Number of users who submitted this category</p>
                                </div>
                                <div className="widgets-icons bg-light-success text-success rounded-circle">
                                    <i className="bx bx-detail"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-12 col-lg-6">
                    <div className="card radius-15">
                        <div className="card-body">
                            <div className="media align-items-center">
                                <div className="media-body">
                                    <h4 className="mb-0 font-weight-bold">{parseFloat(averageScore).toFixed(2)}</h4>
                                    <p className="mb-0">Average score of users who attempted this category</p>
                                </div>
                                <div className="widgets-icons bg-light-primary text-primary rounded-circle">
                                    <i className="bx bx-poll"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-lg-6">
                    <div className="card radius-15">
                        <div className="card-body">
                            <div className="media align-items-center">
                                <div className="media-body">
                                    <h4 className="mb-0 font-weight-bold">{highestScore}</h4>
                                    <p className="mb-0">Highest score in this category</p>
                                </div>
                                <div className="widgets-icons bg-light-success text-success rounded-circle">
                                    <i className="bx bx-detail"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-12 col-lg-6">
                    <div className="card radius-15">
                        <div className="card-body">
                            <div className="media align-items-center">
                                <div className="media-body">
                                    <h4 className="mb-0 font-weight-bold">{lowestScore}</h4>
                                    <p className="mb-0">Lowest score in this category</p>
                                </div>
                                <div className="widgets-icons bg-light-primary text-primary rounded-circle">
                                    <i className="bx bx-poll"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-lg-6">
                    <div className="card radius-15">
                        <div className="card-body">
                            <div className="media align-items-center">
                                <div className="media-body">
                                    <h4 className="mb-0 font-weight-bold">{parseFloat(averageTimeTaken).toFixed(2)}</h4>
                                    <p className="mb-0">Average time taken to complete this category</p>
                                </div>
                                <div className="widgets-icons bg-light-success text-success rounded-circle">
                                    <i className="bx bx-detail"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-12 col-lg-6">
                    <div className="card radius-15">
                        <div className="card-body">
                            <div className="media align-items-center">
                                <div className="media-body">
                                    <h4 className="mb-0 font-weight-bold">{paidUsersCount}</h4>
                                    <p className="mb-0">Number of paid users who attempted this category</p>
                                </div>
                                <div className="widgets-icons bg-light-primary text-primary rounded-circle">
                                    <i className="bx bx-poll"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CategoryStats

